import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Where the fallback sends the admin back to; also where Login lands them.
const HOME_PATH = '/users';

const fallbackStyle = { padding: '4em 2em', textAlign: 'center' };
const actionStyle = { margin: '0 0.5em' };

/**
 * Catches a render error in the page below it and offers a way out, instead of
 * React unmounting the whole tree and leaving a blank white page.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;
    const { children, pathname } = this.props;

    if (!hasError) {
      return children;
    }

    return (
      <div role="alert" style={fallbackStyle}>
        <h2>Something went wrong on this page.</h2>
        <p>Reload the page to try again.</p>
        <button type="button" style={actionStyle} onClick={() => window.location.reload()}>
          Reload page
        </button>
        {/* On HOME_PATH itself the link would push the same path: the key would
            not change, so the fallback would stay. Reload is the way out there. */}
        {pathname !== HOME_PATH && (
          <Link to={HOME_PATH} style={actionStyle}>Back to User Management</Link>
        )}
      </div>
    );
  }
}

/**
 * The boundary keyed by path: navigating to another path (the fallback link,
 * the browser's Back button) mounts a fresh boundary with no error.
 */
export default function RouteErrorBoundary({ children }) {
  const { pathname } = useLocation();
  return <ErrorBoundary key={pathname} pathname={pathname}>{children}</ErrorBoundary>;
}
